import { CaseTitle } from 'shared/components/styled/Cases';

import type { Option } from 'shared/models/common';
import { CaseStatuses } from 'utils/enums';

import styled from 'shared/utils/styled';

type StatusAccessories = Partial<{
  status: CaseStatuses | null;
}>;

export const Status = styled('span', {
  shouldForwardProp: (prop) => prop !== 'status',
})<StatusAccessories>(({ status, theme }) => ({
  ...(status && {
    color: [CaseStatuses.Approved, CaseStatuses.Completed].includes(status)
      ? theme.palette.success.main
      : [CaseStatuses.Canceled, CaseStatuses.Rejected].includes(status)
      ? theme.palette.error.main
      : theme.palette.primary.main,
  }),
}));

const CaseNumber = styled('span')(({ theme }) => ({
  fontSize: '0.75em',
}));

type CaseHeaderProps = {
  title: string;
  number: string | null;
  status?: Option<CaseStatuses> | null;
};

const CaseHeader = ({ number, status, title }: CaseHeaderProps) => (
  <CaseTitle>
    {title} -{' '}
    <CaseNumber>
      {number ? `#${number}` : ''}
      {status && (
        <>
          - <Status status={status.Value}>{status.Label}</Status>
        </>
      )}
    </CaseNumber>
  </CaseTitle>
);

export default CaseHeader;
